'use client'

import { useSyncExternalStore } from 'react'

const subscribe = () => () => {}

function useShowCloseButton() {
  return useSyncExternalStore(
    subscribe,
    () => {
      // Check 1: SPA navigation — the initial page load URL differs from the current URL,
      // meaning Next.js client-side navigated here from another page on the site.
      const navEntry = performance.getEntriesByType('navigation')[0] as
        | PerformanceNavigationTiming
        | undefined
      if (navEntry && new URL(navEntry.name).pathname !== window.location.pathname) {
        return true
      }

      // Check 2: Full page load from same origin (e.g. internal link with target="_blank")
      try {
        if (document.referrer && new URL(document.referrer).origin === window.location.origin) {
          return true
        }
      } catch {
        // Invalid referrer URL
      }

      return false
    },
    () => false,
  )
}

export default function CloseButton() {
  const show = useShowCloseButton()

  if (!show) return null

  return (
    <button
      onClick={() => window.history.back()}
      className="absolute top-4 right-4 z-10 inline-flex cursor-pointer items-center justify-center rounded-full bg-black/70 p-2.5 transition-colors hover:bg-white/10 md:top-6 md:right-6 md:p-3"
      aria-label="Bezárás"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        fill="currentColor"
        className="size-7 text-white drop-shadow-md md:size-9"
      >
        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
      </svg>
    </button>
  )
}
